<template lang="html">

  <section class="ficha -practica">

    <template v-if="!!data">

      <h2 class="ficha-title" :style="styles.colorBasic">{{$t('datos_practica')}}</h2>

      <article class="group">
        <div class="contenedor-data" v-if="!!data.idPractica">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('id_practica')}}</h4>
          <p>{{data.idPractica}}</p>
        </div>
        <div class="contenedor-data" v-if="!!data && data.nombreGestorOferta">
          <h4 class="data-title" :style="styles.colorBasic">{{(brand.encabezados.tutorados && brand.encabezados.tutorados.nombreGestorOferta) ? brand.encabezados.tutorados.nombreGestorOferta.nombre : $t('nombre_gestor') }}</h4>
          <p>{{data.nombreGestorOferta}}</p>
        </div>

      </article>

      <article class="group">

        <h3 class="group-title" :style="styles.colorBasic">{{$t('detalles_puesto')}}</h3>

        <div class="contenedor-data" v-if="!!data.tipoCreditos">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('tipo_practica')}}</h4>
          <p>{{data.tipoCreditos}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.puesto">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('nombre_puesto')}}</h4>
          <p>{{data.puesto}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.areaFuncional">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('area_funcional')}}</h4>
          <p>{{data.areaFuncional}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.ayudaAlEstudio">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('ayuda_al_estudio')}}</h4>
          <p>{{data.ayudaAlEstudio}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.funciones">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('tareas_desarrollar')}}</h4>
          <p v-html="data.funciones"></p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.tareas1">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('tarea')}} 1</h4>
          <p v-html="data.tareas1"></p>
        </div>
        <div class="contenedor-data -full" v-if="!!data.tareas2">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('tarea')}} 2</h4>
          <p v-html="data.tareas2"></p>
        </div>
        <div class="contenedor-data -full" v-if="!!data.tareas3">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('tarea')}} 3</h4>
          <p v-html="data.tareas3"></p>
        </div>
        <div class="contenedor-data -full" v-if="!!data.otrasTareas">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('otras_tareas')}}</h4>
          <p v-html="data.otrasTareas"></p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.motivosSolicitudValidacion">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('motivos_solicitud')}}</h4>
          <p v-html="data.motivosSolicitudValidacion"></p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.urlAnexoProrroga">
          <arrow-link :text="$t('ver_documento_prorroga')" :to="data.urlAnexoProrroga" :external="true" :blank="true">
          </arrow-link>
        </div>

      </article>


      <article class="group">

        <h3 class="group-title" :style="styles.colorBasic">{{$t('duracion')}}</h3>

        <div class="contenedor-data" v-if="!!data.fechaInicio">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_inicio')}}</h4>
          <p>{{data.fechaInicio}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.fechaFin">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_finalizacion')}}</h4>
          <p>{{data.fechaFin}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.horario">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('horario')}}</h4>
          <p>{{data.horario}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.horasDia">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('n_horas_dia')}}</h4>
          <p>{{data.horasDia}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.totalHoras">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('horas_totales')}}</h4>
          <p>{{data.totalHoras}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.totalHoras">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('dias_semana')}}</h4>
          <p>{{data.numDiasSemana}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.HorasCurriculares">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('horas_curriculares')}}</h4>
          <p>{{data.HorasCurriculares}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.HorasExtracurriculares">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('horas_extracurriculares')}}</h4>
          <p>{{data.HorasExtracurriculares}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.NumeroCreditos">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('numero_creditos')}}</h4>
          <p>{{data.NumeroCreditos}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.nombreCentroTrabajoSucursal">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('nombre_centro')}}</h4>
          <p>{{data.nombreCentroTrabajoSucursal}}</p>
        </div>

      </article>

      <article class="group" v-if="!!data.nombreTutorEmpresa">

        <h3 class="group-title" :style="styles.colorBasic">{{$t('tutor_empresa')}}</h3>

        <div class="contenedor-data -full">
          <div class="full-children" v-if="!!data.nombreTutorEmpresa">
            <h4 class="data-title" :style="styles.colorBasic">{{$t('nombre_apellidos')}}</h4>
            <p>{{data.nombreTutorEmpresa}}</p>
          </div>
          <div class="full-children" v-if="!!data.emailTutorEmpresa">
            <h4 class="data-title" :style="styles.colorBasic">{{$t('email')}}</h4>
            <p><a :href="'mailto'+data.emailTutorEmpresa">{{data.emailTutorEmpresa}}</a></p>
          </div>
          <div class="full-children" v-if="!!data.telefonolTutorEmpresa">
            <h4 class="data-title" :style="styles.colorBasic">{{$t('telefono')}}</h4>
            <p><a :href="'tel:'+data.telefonolTutorEmpresa">{{data.telefonolTutorEmpresa}}</a></p>
          </div>
          <div class="full-children" v-if="!!data.departamento">
            <h4 class="data-title" :style="styles.colorBasic">{{$t('departamento')}}</h4>
            <p>{{data.departamento}}</p>
          </div>
        </div>

        <div class="contenedor-data -full" v-if="!!data.urlAnexo">
          <arrow-link :text="$t('ver_anexo_practicas')" :to="data.urlAnexo" :external="true" :blank="true">
          </arrow-link>
        </div>


      </article>

      <article class="group">

        <h3 class="group-title" :style="styles.colorBasic">{{$t('cuestionarios')}}</h3>

        <template v-if="brand.verEvaluaciones"> 
          <a v-if="!!data.idContestacionEncuestaTutorEmpresa"
          @click="$emit('setEncuesta',data.idContestacionEncuestaTutorEmpresa)"
          title="Consultar la evaluación de la empresa" class="row-start enlace-cuestionario"
          :style="styles.colorBasic">{{$t('ver_evaluacion_empresa')}} <only-arrow></only-arrow></a>
        </template>
        <template v-else>
          <a v-if="!!data.idContestacionEncuestaTutorEmpresa"
          @click="$emit('setEncuesta',data.idContestacionEncuestaTutorEmpresa)"
          title="Consultar el cuestionario de la empresa" class="row-start enlace-cuestionario"
          :style="styles.colorBasic">{{$t('ver_cuestionario_empresa')}} <only-arrow></only-arrow></a>
        </template>

        <template v-if="brand.verEvaluaciones">
          <a v-if="!!data.idContestacionEncuestaAlumno" @click="$emit('setEncuesta',data.idContestacionEncuestaAlumno)"
          title="Consultar la evaluación del alumno" class="row-start enlace-cuestionario"
          :style="styles.colorBasic">{{$t('ver_evaluacion_alumno')}} <only-arrow></only-arrow></a>
        </template>
        <template v-else>
          <a v-if="!!data.idContestacionEncuestaAlumno" @click="$emit('setEncuesta',data.idContestacionEncuestaAlumno)"
          title="Consultar el cuestionario del alumno" class="row-start enlace-cuestionario"
          :style="styles.colorBasic">{{$t('ver_cuestionario_alumno')}} <only-arrow></only-arrow></a>
        </template>

        <template v-if="brand.verEvaluaciones">
          <a v-if="!!data.idContestacionEncuestaTutorAcademico"
          @click="$emit('setEncuesta',data.idContestacionEncuestaTutorAcademico)"
          title="Consultar la evaluación del tutor académico" class="row-start enlace-cuestionario"
          :style="styles.colorBasic">{{$t('ver_evaluacion_tutor')}} <only-arrow></only-arrow></a>
        </template>
        <template v-else>
          <a v-if="!!data.idContestacionEncuestaTutorAcademico"
          @click="$emit('setEncuesta',data.idContestacionEncuestaTutorAcademico)"
          title="Consultar el cuestionario del tutor académico" class="row-start enlace-cuestionario"
          :style="styles.colorBasic">{{$t('ver_cuestionario_tutor')}} <only-arrow></only-arrow></a>
        </template>

        <a v-if="!!data.urlActillacalificacion" :href="data.urlActillacalificacion" target="_blank"
          title="Consultar actilla de calificación" class="row-start enlace-cuestionario" :style="styles.colorBasic">{{$t('ver_actilla_calificacion')}} <only-arrow></only-arrow></a>

        <a v-if="!!!brand.ocultarDocumentoEvaluacion && !!data.urlDocEvaluacionTutor" :href="data.urlDocEvaluacionTutor"
          target="_blank" title="Consultar documento de Evaluación del tutor" class="row-start enlace-cuestionario"
          :style="styles.colorBasic">{{$t('documento_evaluacion')}} <only-arrow></only-arrow></a>
        
        <a class="row-start btn add-documentacion -xs" :style="styles.solidPrimary" @click="solicitarMailEncuesta(data.idPractica, 3)"
          v-if="brand.ocultarDocumentoEvaluacion && !data.idContestacionEncuestaAlumno">{{$t('solicitar_cuestionario_alumno')}}</a>
        
        <a class="row-start btn add-documentacion -xs" :style="styles.solidPrimary" @click="solicitarMailEncuesta(data.idPractica, 4)"
          v-if="brand.ocultarDocumentoEvaluacion && !data.idContestacionEncuestaTutorEmpresa">{{$t('solicitar_cuestionario_tutor')}}</a>
       
        <div class="full-children"
          v-if="!!data.cuestionariosTutorAcademicoContestados && data.cuestionariosTutorAcademicoContestados.length != 0">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('cuestionarios_tutor')}}</h4>
          <template v-for="el in data.cuestionariosTutorAcademicoContestados">
            <a @click="$emit('setEncuesta',el.clave)" :title="el.valor" class="row-start enlace-cuestionario"
              :style="styles.colorBasic">{{el.valor}} <only-arrow></only-arrow></a>
          </template>
        </div>

      </article>


      <article class="group" v-if="!!data.seguimientoTutorados">

        <h3 class="group-title" v-if="!!Object.values(data.seguimientoTutorados).some(e=> !!e)"
          :style="styles.colorBasic">{{$t('seguimiento')}}</h3>

        <div class="contenedor-data -full" v-if="!!data.seguimientoTutorados.fechaAsignacion">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_practica')}}</h4>
          <p>{{data.seguimientoTutorados.fechaAsignacion}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.seguimientoTutorados.fechaLimiteEntregaEstudiante">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_limite_estudiante')}}</h4>
          <p>{{data.seguimientoTutorados.fechaLimiteEntregaEstudiante}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.seguimientoTutorados.fechaCuestionarioEstudiante">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_cuestionario_estudiante')}}</h4>
          <p>{{data.seguimientoTutorados.fechaCuestionarioEstudiante}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.seguimientoTutorados.fechalimiteEntregaEmpresa">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_limite_empresa')}}</h4>
          <p>{{data.seguimientoTutorados.fechalimiteEntregaEmpresa}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.seguimientoTutorados.fechaCuestionarioEmpresa">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_cuestionario_empresa')}}</h4>
          <p>{{data.seguimientoTutorados.fechaCuestionarioEmpresa}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.seguimientoTutorados.fechaMarcaEvaluacionPendiente">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_cierre_pendiente')}}</h4>
          <p>{{data.seguimientoTutorados.fechaMarcaEvaluacionPendiente}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.seguimientoTutorados.fechaMarcaEvaluacionTramitada">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_cierre_tramitado')}}</h4>
          <p>{{data.seguimientoTutorados.fechaMarcaEvaluacionTramitada}}</p>
        </div>


        <div class="contenedor-data -full" v-if="!!data.motivosSolicitudValidacion">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('motivos_solicitud_validacion')}}</h4>
          <p>{{data.motivosSolicitudValidacion}}</p>
        </div>

      </article>



      <template v-if="uploaddoc">

        <article class="group -wo-flex">

          <template v-if="!!data.documentacion && data.documentacion.length != 0">


            <h2 class="ficha-title -documentacion-practica" :style="styles.colorBasic"
              v-if="data.documentacion.length> 0 || data.idEstadoValidacion == 2">{{$t('documentacion_tutor')}}
            </h2>

            <template v-for="documento in data.documentacion">
              <arrow-link :text="`${documento.nombre}`" :to="documento.enlace" :external="true" :blank="true">
              </arrow-link>
            </template>

          </template>

          <template v-if="data.idEstadoValidacion == 2">

            <a class="btn add-documentacion -xs" :style="styles.solidPrimary"
              @click="showAddDocumentacion('addDocumentoPractica')" v-if="!showadddocumentacion">{{$t('anadir_documentacion')}}</a>

            <a class="btn add-documentacion -xs" :style="styles.solidPrimary"
              @click="showAddDocumentacion('addDocumentoPracticaParaAlumno')"
              v-if="!!data.urlDocEvaluacionTutor && !showadddocumentacion && !!!brand.ocultarDocumentoEvaluacion">{{$t('anadir_evaluacion')}}</a>

            <add-documentacion v-if="showadddocumentacion" @setdocumentacion="setdocumentacion" :type="uploadtype"
              @close="closeAddDocumentacion"></add-documentacion>

          </template>

        </article>

      </template>


      <template v-if="!!data.documentacionPorPrograma && data.documentacionPorPrograma.length != 0">

        <article class="group -wo-flex">

          <h3 class="group-title" :style="styles.colorBasic">{{$t('documentacion_por_programas')}}</h3>

          <template v-for="documento in data.documentacionPorPrograma">

            <div class="contenedor-data -full column-start">
              <h4 class="data-title" :style="styles.colorBasic">{{documento.tituloPrograma}}</h4>
              <p>{{documento.fecha}}</p>
              <arrow-link :text="$t('ver_documento')" :to="documento.enlace" :external="true" :blank="true"></arrow-link>
            </div>

          </template>

        </article>

      </template>



      <template v-if="data.documentacionOfrecida && data.documentacionOfrecida.length != 0">

        <article class="group -wo-flex">

          <h3 class="group-title" :style="styles.colorBasic">{{$t('documentacion_ofrecida')}}</h3>

          <template v-for="el in data.documentacionOfrecida">

            <div class="contenedor-data -full column-start">

              <arrow-link :text="el.nombre" :to="el.enlace" :external="true" :blank="true"></arrow-link>
            </div>

          </template>

        </article>

      </template>


      <template v-if="documentacionPendiente && documentacionPendiente.length != 0">

        <article class="group -wo-flex">

          <h3 class="group-title" :style="styles.colorBasic">{{$t('documentacion_pendiente_subir')}}</h3>

          <template v-for="el in documentacionPendiente">

            <div class="contenedor-data -full column-start">
              <arrow-link :text="el.nombre" :to="el.enlace" :external="true" :blank="true"></arrow-link>
              <a class="btn add-documentacion -xs" :style="styles.solidPrimary"
                @click="showAddDocumentacion('addDocumentoPractica')" v-if="!showadddocumentacion">{{$t('anadir_documento')}}</a>
              <add-documentacion :doc="el" :name="el.nombre" :idTipoDocumentoParaPractica="el.idTipoDocumentacionParaPractica " v-if="showadddocumentacion" @setdocumentacion="setdocumentacion" :type="uploadtype"
                @close="closeAddDocumentacion"></add-documentacion>
            </div>

          </template>

        </article>

      </template>


    </template>

  </section>

</template>

<script lang="js">
  import {
    mapGetters,
    mapActions
  } from 'vuex';

  import onlyArrow from '@/components/parts/icons/only-arrow';
  import arrowlink from '@/components/parts/icons/arrow-link';

  import addDocumentacion from '@/components/parts/add-documentacion';

  export default {
    name: 'ficha-practica',
    props: ['data'],
    data() {
      return {
        showadddocumentacion: false,
        uploadtype: '',
        documentacionPendiente: []
      }
    },
    mounted() {
      if (this.data.documentacionPendiente && this.data.documentacionPendiente.length != 0) {
        this.data.documentacionPendiente.forEach(e => {
          e.idPractica = this.data.idPractica,
            e.ficheroB64 = "",
            e.extension_adjunto = "",
            e.download = false,
            e.idTipoDocumentoParaPractica = e.idTipoDocumentacionParaPractica;
          this.documentacionPendiente.push(e);
        })
      }
    },
    methods: {
      ...mapActions(['solicitarCuestionario']),
      solicitarMailEncuesta(idPractica, tipo) {
        let data = {
          "idPractica": idPractica,
          "tipo": tipo
        }
        this.solicitarCuestionario(data).then(r => {
          this.showadddocumentacion = false;
        });
      },
      setdocumentacion(value) {
        this.$emit('setDocumentoPractica', value);
        this.showadddocumentacion = false;
      },
      showAddDocumentacion(value) {
        this.showadddocumentacion = true;
        this.uploadtype = value;
      },
      closeAddDocumentacion() {
        this.uploadtype = '';
        this.showadddocumentacion = false;
      }

    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        documentos: 'getDocumentos',
        uploaddoc: 'getCanUploadDocPracticas',
        brand : 'getBrand',
        lang : 'getLanguage'
      }),
      showCuestionarios() {
        let lookin = ['urlDocEvaluacionTutor', 'idContestacionEncuestaAlumno', 'idContestacionEncuestaTutorEmpresa', 'urlActillacalificacion', 'idContestacionEncuestaTutorAcademico'];
        let show = false;

        lookin.forEach(id => {
          if (!!this.data[id]) {
            show = true;
          }
        });

        if (!show && !!this.data.cuestionariosTutorAcademicoContestados) {
          show = (this.data.cuestionariosTutorAcademicoContestados.length != 0)
        }

        return show;

      }
    },
    components: {
      'only-arrow': onlyArrow,
      'arrow-link': arrowlink,
      'add-documentacion': addDocumentacion,
    }

  }
</script>

<style scoped lang="scss">
  .enlace-cuestionario {
    font-size: 14px;
    text-transform: uppercase;
    margin-right: 5px;
    font-weight: 600;
    width: 100%;
    text-decoration: underline;
    cursor: pointer;

    svg {
      width: 15px;
      margin-left: 5px;
    }
  }

  .add-documentacion {
    margin-top: 10px;
  }

  @media screen and (max-width: 360px) {
    .enlace-cuestionario {
      font-size: 12px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/ficha-practica.vue